import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../../../../utilities/LocalizationModule";
import { CheckinTypes } from "../../redux/api/local/api-local-interfaces";

export interface IVersionSelectorProps {
    multipleFilesSelected: boolean;
    level: number;
    majorVersion: number;
    minorVersion: number;
    checkinTypeChanged?: (checkinType: CheckinTypes) => void;
}

export const VersionSelector = (props: IVersionSelectorProps) => {
  const languageStrings = React.useContext(LanguageContext);
  
  const { multipleFilesSelected, level, majorVersion, minorVersion, checkinTypeChanged } = props;
  const [options, setOptions] = React.useState<IChoiceGroupOption[]>([])
  let defaultSelectedKey = "0";

  React.useEffect(() => {
    let choiceOptions: IChoiceGroupOption[] = [];

    if (multipleFilesSelected) {
      choiceOptions.push(
        { key: '0', text: `${languageStrings.VersionMinorDraft}` },
        { key: '1', text: `${languageStrings.VersionMajorPublished}` }
      );
    } else {
      //major version
      if (level === 1) {
        choiceOptions.push(
          { key: '0', text: `${majorVersion}.${minorVersion + 1} ${languageStrings.VersionMinorDraft}` },
          { key: '1', text: `${majorVersion + 1}.0 ${languageStrings.VersionMajorPublished}` }
        );
      }

      //minor version
      if (level === 2) {
        choiceOptions.push(
          { key: '0', text: `${majorVersion}.${minorVersion + 1} ${languageStrings.VersionMinorDraft}` },
          { key: '1', text: `${majorVersion + 1}.0 ${languageStrings.VersionMajorPublished}` },
          { key: '2', text: `${majorVersion}.${minorVersion} ${languageStrings.VersionMinorOverwrite}` }
        );
      }

      //checked out
      if (level === 255) {
        choiceOptions.push(
          { key: '0', text: `${majorVersion}.${minorVersion} ${languageStrings.VersionMinorDraft}` },
          { key: '1', text: `${majorVersion + 1}.0 ${languageStrings.VersionMajorPublished}` }
        );

        if (minorVersion > 1) {
          choiceOptions.push(
            { key: '2', text: `${majorVersion}.${minorVersion - 1} ${languageStrings.VersionMinorOverwrite}` }
          );
        }
      }
    }

    setOptions(choiceOptions);
  }, []);

  const _onChange = (ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void => {
    checkinTypeChanged(+option.key)
  }

  return (
    <>
        <ChoiceGroup defaultSelectedKey={defaultSelectedKey} options={options} onChange={_onChange} label={languageStrings.Version} required={true} />
    </>
  );
};

